
import { Translation, Locale } from './types';

export interface ExtendedTranslation extends Translation {
  aboutDescription: string;
  advantages: {
    title: string;
    list: { title: string; desc: string; icon: string }[];
  };
  credentials: {
    title: string;
  };
  exhibitionsSnap: {
    title: string;
  };
  industries: {
    title: string;
    list: { title: string; icon: string }[];
  };
}

export const translations: Record<Locale, ExtendedTranslation> = {
  zh: {
    nav: { about: '关于我们', services: '业务领域', exhibitions: '展会计划', contact: '联系我们' },
    aboutDescription: '上海爱优企服会展有限公司，立足于俄语市场，聚焦中俄双边贸易，通过多年的运营，公司已累计服务“中国出口俄罗斯企业”上千家。2024年爱优企服成功与俄罗斯龙城电商科技园，俄罗斯天雅汽配城牵手合作。为更好的服务于中国出口俄罗斯贸易不懈努力。爱优企服聚焦中国企业“走出去”解决方案，通过在俄罗斯落地的实体场景（常年展厅/MOQ订货中心）、线下买家运营方案（买卖双方链接）、线上线下双向分销的模式，为“中国制造”量身打造拓展俄语市场的外贸营销的综合服务。',
    advantages: {
      title: '我们的优势',
      list: [
        { title: '资深团队', desc: '团队成员有着多元化背景，丰富商务经验，拥有多门外语能力与海外工作经历', icon: '👥' },
        { title: '优质资源', desc: '深耕国际市场多年，着重布局一带一路国家，拥有丰富商务资源与数据库信息', icon: '💎' },
        { title: '专业推广', desc: '深耕俄语区，辐射全球贸易市场，有强大的海外服务团队', icon: '📢' },
        { title: '多元服务', desc: '线上线下融合，国内国外并进，提供各类商务咨询等高增值服务', icon: '🛠️' }
      ]
    },
    credentials: {
      title: '各类资质'
    },
    exhibitionsSnap: {
      title: '往届风采'
    },
    hero: { 
      title: '连接中俄市场，助力中国制造', 
      subtitle: '深耕俄语市场，为您提供专业的组展、搭建及一站式商务落地咨询服务，助力中国企业走出去。', 
      cta: '立即咨询' 
    },
    services: {
      title: '核心业务',
      list: [
        { title: '海外组展', desc: '组织中国优质企业参加俄罗斯顶级行业展会，拓展海外订单。', icon: '🌍' },
        { title: '展台设计搭建', desc: '莫斯科本地工程团队，提供从设计到落地的一站式搭建服务。', icon: '🏗️' },
        { title: '莫斯科MOQ订货中心', desc: '莫斯科核心商圈现货展示与分销中心，支持小额起订与快速补货。', icon: '🏢' },
        { title: '商务咨询', desc: '中俄双语顾问团队，解决法律、物流、清关及市场准入难题。', icon: '💼' }
      ]
    },
    industries: {
      title: '优势行业',
      list: [
        { title: '小家电', icon: '🏠', image: '/core_business_images/xjd.jpg' },
        { title: '汽车配件', icon: '🚗', image: '/core_business_images/qcpj.jpg' },
        { title: '玩具', icon: '🧸', image: '/core_business_images/wj.jpg' },
        { title: '清洁用品', icon: '🧹', image: '/core_business_images/qj.jpg' }
      ]
    },
    workflow: {
      title: '服务流程',
      list: [
        { title: '需求沟通', desc: '深入了解您的产品特点与出海目标', icon: '01' },
        { title: '方案定制', desc: '为您量身打造展位设计与市场落地策略', icon: '02' },
        { title: '签约服务', desc: '确立合作关系，全方位启动筹备工作', icon: '03' },
        { title: '落地执行', desc: '从莫斯科搭建到现场买家运营全程护航', icon: '04' }
      ]
    },
    exhibitionTable: {
      title: '2026 重点展会计划',
      columns: ['展会名称', '城市', '时间', '状态'],
      list: [
        { 
          id: 1, 
          name: '俄罗斯家庭生活用品博览会（HOUSEHOLD EXPO）', 
          city: '莫斯科', 
          date: '2026 年 03 月 17-19 日', 
          status: '火热招展',
          details: `### 俄罗斯家庭生活用品博览会（HOUSEHOLD EXPO）参展简报

#### 一、核心信息
* **展会中英文名称**：俄罗斯家庭生活用品博览会（HOUSEHOLD EXPO）
* **举办城市**：俄罗斯莫斯科
* **举办时间**：2026 年 03 月 17-19 日（春季）
* **举办地址**：莫斯科 CROCUS 展览中心

#### 二、展会详情
**（一）基本概况**
主办单位为 MOKKA EXPO 集团，协办单位为 Mayer J，由俄联邦工商会、莫斯科市政府赞助，得到俄罗斯家庭用品协会、俄罗斯工艺品协会、欧亚商品协会的大力支持。
举办周期为 1 年 2 届（春秋两季），是专为家庭用品举办的国际性展览会，也是俄罗斯唯一的家电及家庭用品、礼品专业展。
展会定位聚焦俄罗斯最大的家庭用品生产制造商与批发商，为全球参展企业搭建优质国际贸易平台，集中展示全球家庭用品行业的发展水平与潮流趋势。

**（二）规模与影响力**
* **往届成果**：2025 年秋季展会（9 月 9 日 - 11 日）展出面积达 4 万平米，吸引 22 个国家 and 地区的 580 家品牌企业参展，涵盖多个国家，专业买家超 30000 人次；中国展区面积 20000 平米，逾百家中国企业参展，市场反应热烈，续展率高达 60%。
* **本届预计规模**：2026 年春季展会将启用十大展馆，预计展出面积 10 万平方米，吸引 65000 名专业买家；俄罗斯及周边国家大型展商将以特装形式亮相。
* **市场背景**：俄罗斯已撤出大部分欧美商品，正持续加强与中国的合作，中俄市场具备紧密不可替代的战略性地位。

**（三）同期展会**
同期将举办圣诞用品及节日礼品展、玩具展、户外及休闲用品展、日化用品及个护展等，形成产业联动效应。

**（四）展览内容**
* **家用电器及家庭保健**：各类家电、吸尘器、节能设备、取暖器、加湿器、按摩器具等；
* **家用清洁及家居用品**：浴室用具、清洁用具、收纳用品、家用五五金、塑料、陶瓷、玻璃等；
* **厨房用品及餐厨器皿**：各类餐具、炊具、烤盘、玻璃器皿、厨房工具等；
* **园艺及户外用品**：花园工具、装饰品、露营用品、野炊用品、铁艺家具等；
* **装饰及节日用品**：圣诞礼品、季节性饰品、家纺、灯具、工艺礼品等；
* **家用日化及个护产品**：洗涤用品、沐浴露、香氛、美容护肤、环保产品等。

**（五）参展支持**
组展方提供 3 天展期高密对接买家、展后 365 天 MOQ 订货中心常年展厅、本土分销、品牌化运营等；协助企业了解行业趋势，提供完整证明材料助力申请地方补贴。`
        },
        { 
          id: 2, 
          name: '2026 年第 45 届俄罗斯服装及时尚博览会（CPM）', 
          city: '莫斯科', 
          date: '2026 年 2 月 17-20 日', 
          status: '接受预定',
          details: `### 2026 年第 45 届俄罗斯服装及时尚博览会（CPM）参展简报

#### 一、核心信息
* **展会中英文名称**：2026 年第 45 届俄罗斯服装及时尚博览会（CPM）
* **举办城市**：俄罗斯莫斯科
* **举办时间**：2026 年 2 月 17 日至 20 日
* **举办地址**：CROCUS EXPO（Крокус Экспо）3 号馆 13、14、15 厅

#### 二、展会详情
**（一）基本概况**
* **主办单位**：德国杜塞尔多夫展览公司
* **展会资质**：已通过 UFI（国际展览联盟）认证，是俄罗斯联邦乃至东欧地区最大的专业服装展会。
* **展会价值**：为全球服装及时尚行业提供高效商贸对接平台，助力企业拓展东欧市场，对俄罗斯轻工业发展起到重要推动作用。

**（二）展览内容**
展会涵盖 50 种不同种类的产品，集中展示 2200 个品牌，具体包括：男装、女装、童装、休闲服、皮革装、婚纱、晚礼服、内衣、泳装、配饰、箱包、鞋等。

**（三）展会特色与活动**
* **行业交流**：举办专题座谈会、研讨会、新款时装发布会。
* **“设计师池”项目**：支持年轻设计师展示自有系列，助力挖掘商业潜力。
* **“CPM 品牌角”项目**：为本土时尚行业小品牌创造增长平台。

**（四）宣传与商贸对接**
* **宣传推广**：定制宣传视频、展馆广告；展前向采购商发送邀请邮件，派发宣传礼品及展商手册。
* **商贸配对**：构建“展前-展中-展后”全周期精准配对体系，提升商贸合作效率。`
        },
        {
          id: 3,
          name: '第 59 届俄罗斯国际户外旅游狩猎展',
          city: '莫斯科',
          date: '2026 年 02 月 20-23 日',
          status: '接受预定',
          details: `### 第 59 届俄罗斯国际户外旅游狩猎展（Hunting and Fishing in Russia）参展简报

#### 一、核心信息
* **展会中英文名称**：第 59 届俄罗斯国际户外旅游狩猎展（Hunting and Fishing in Russia）
* **举办城市**：俄罗斯莫斯科
* **举办时间**：2026 年 02 月 20 日至 23 日
* **举办地址**：莫斯科 VDNH 维登汉展览中心（55、57 号馆）

#### 二、展会详情
**（一）基本概况**
* **主办单位**：EC “Expodesign”，得到国际展览协会、俄罗斯展览与博览会联盟（RUEF）、俄罗斯联邦工商会、莫斯科展览工商会和博览会组织协会支持
* **举办周期**：一年两届（2 月 / 9 月）
* **展会历史与定位**：创立于 1996 年，当年 2 月 6 日首次在莫斯科维登汉展馆举办，是俄罗斯最大的户外狩猎渔具展会，行业规模领先全世界。展会宗旨是为全球狩猎、旅游及户外爱好者提供交流平台，展示行业最新产品与发展态势，为企业开拓俄罗斯市场搭建关键桥梁。

**（二）规模与影响力**
* **上届成果**：吸引超过 700 家来自俄罗斯、白俄罗斯、拉脱维亚、西班牙、立陶宛、波兰、韩国、南非、挪威、日本、塞尔维亚等国家和地区的企业参展；展出面积达 27000 多平米，观展人数超 55000 人次，其中大型专业采购商达 11000 多人次。
* **行业热度**：展商数量、观众数量持续上升，当地采购商质量不断提高；上届展会吸引俄罗斯 32 个地区的专业人士参与，地区游客占比达 27%，覆盖范围广泛。

**（三）展品范围**
* **户外旅游用品**：户外专业服饰、运动服、迷彩服饰、军需用品、户外箱包用具、野炊用品、劳保服饰、户外手套、帽子、鞋、腰带等；
* **渔具**：渔具配件、鱼竿、鱼钩、鱼饵等；
* **狩猎相关**：狩猎武器、步枪、刀、剪刀、长矛、弓等；
* **陆地运输**：四轮车、雪地车、越野车及相关配件等；
* **跟踪设备及光学产品**：光学瞄准镜、热成像仪及相关配件等；
* **活动旅游相关**：捕鱼和狩猎旅游服务、休闲设备、帐篷、旅游基地设备等；
* **水上运输**：船只、游艇、快艇、充气艇、船用发动机及相关配件等。

**（四）市场前景**
* **市场基础**：俄罗斯地跨欧亚两洲，是世界领土面积最大的国家，户外旅游、打猎钓鱼是俄罗斯男性最喜爱的运动之一。随着人口增长，相关爱好者数量持续增加，国内拥有数千家独立渔具店，各级市场分布广泛，为国外品牌提供了广阔的市场空间。
* **发展机遇**：受近 3 年疫情及俄乌战争影响，中国企业此前参展较少，但俄罗斯对军需用品需求激增，同时众多欧美国家企业撤出俄罗斯市场，采购商需求持续上升。2024 年 2 月参展的中国企业收获颇丰，尤其是户外服饰鞋帽类展品深受俄罗斯采购者青睐，当前正是中国企业进驻欧亚市场的最佳时机。

**（五）参展支持**
组展方提供全俄专业展会对接服务，包括 3 天展期高密对接买家、展后 365 天 MOQ 订货中心常年展厅、全俄多场展会产品曝光、本土分销、品牌化运营等配套支持，助力参展企业深耕俄罗斯市场。`
        },
        {
          id: 4,
          name: '2026 俄罗斯家居全品类消费品博览会',
          city: '莫斯科',
          date: '2026 年 04 月 01-04 日',
          status: '接受预定',
          details: `### 2026 俄罗斯家居全品类消费品博览会（MosHome 2026）参展简报

#### 一、核心信息
* **展会中英文名称**：2026 俄罗斯家居全品类消费品博览会（MosHome 2026）
* **举办城市**：俄罗斯莫斯科
* **举办时间**：2026 年 04 月 01 日至 04 日
* **举办地址**：待补充

#### 二、展会详情
**（一）基本概况**
* **主办单位**：ITE 展览集团
* **举办周期**：一年一届
* **展会定位**：专为中国日用消费品、家居装饰及五金产品等打造的 B2B 国际性展览会，核心宗旨是为各类消费品制造商提供开拓新市场、扩大销售规模的契机，是希望拓展俄罗斯家居消费品业务的企业的首选展会.
* **展会特色**：特设 “买家卖家匹配中心”，支持买家与参展商一对一开展采购会谈，商业潜力突出，为参展商创造了前所未有的业务发展与合作建立机会，吸引众多零售界及电商平台目标买家亲临现场.
* **关联展会优势**：是 ITE 集团主办的 “俄罗斯莫斯科国际建材展（MosBuild）” 的姐妹展。MosBuild 已成功举办 30 届，2025 年展会横跨 11 个展厅，总面积达 10 万平方米，汇聚 51 个国家的 1370 多家展商，吸引全球 51 个国家及俄罗斯 86 个地区的 80748 名专业人士参与，国际观众同比增加 47%，稳居俄罗斯、东欧及独联体地区规模和影响力名列前茅的国际性建材行业展会，为家居类消费品企业提供了优质的国际贸易平台.

**（二）同期展会**
* 与俄罗斯最大的建筑和室内装饰展（MosBuild）同期举办，可共享该展会 10000 + 跨展观众资源，大幅提升参展企业品牌知名度与曝光度。

**（三）展品范围**
* **文具礼品及装饰用品**：玩具、文化用品、办公用品、体育及旅游休闲用品、礼品及赠品、装饰工艺品、节日用品、圣诞季装饰、圣诞节庆灯饰、礼品及礼品包装等；
* **家居用品**：家居装饰、家用纺织、浴室用品、铁石制品、编织品、收纳用品、小型家具、灯具、照明设备等；
* **家用电器**：电视机、洗衣机、干衣机、电风扇、空调、取暖器、加湿器、吸尘器、电熨斗、热水器、电热水壶、咖啡机等小家电，以及按摩、保健、个人护理用具、智能家居用品等；
* **日用餐厨**：厨房用品、玻璃陶瓷制品、餐桌饰品、厨房及桌上用布艺纺织品、清洁用品及器皿、家用器皿、塑料产品等；
* **家用纺织**：毛毯、毛巾、地毯、窗帘、浴室帘、靠枕、床上用品、餐桌用纺织品等；
* **婴童玩具**：木质玩具、毛绒玩具、益智玩具、童车、滑板车、婴童日常用品等；
* **宠物用品**：宠物玩具、宠物食品、宠物包装、宠物笼子、宠物美容及医疗用品等；
* **户外花园**：花园工具、五金工具、花园装饰品、露营用品、野炊用品、铁艺及花园家具等；
* **体育健身**：体育用品、户外运动用品、雪上运动及设备、健身器材及配件、运动服饰等。

**（四）市场前景与贸易利好**
* **中俄贸易基础深厚**：中国连续 14 年稳居俄罗斯第一大贸易伙伴国，2024 年俄中贸易额达约 2448 亿美元，此前已连续多年突破关键阈值，预计 2030 年有望迈向 3000 亿美元；中俄贸易本币结算比例已增至 92%，俄罗斯大部分银行接入人民币跨境支付系统 CIPS，贸易结算更便利.
* **俄罗斯市场环境优越**：俄罗斯联邦经济规模位居欧洲第一，近两年 GDP 年均增速超 4%，失业率降至 1992 年以来最低水平（2.3%），计划 2030 年跻身全球营商环境最佳前二十位；2025 年圣彼得堡国际经济论坛吸引 140 多个国家和地区代表参与，国际合作空间广阔.
* **中国企业发展机遇**：中俄全面战略协作伙伴关系处于历史最好水平，俄罗斯实施 “向东看” 战略后，消费者对性价比高的中国产品认知度与接受度持续提升，中高端市场利润空间可观；西方品牌撤出后留下巨大市场空白，加之俄罗斯消费者重视产品质量，为中国企业填补市场空白、深耕当地市场创造了黄金窗口期.

**（五）参展支持**
组展方提供全链条参展配套服务，包括 3 天展期高密对接买家、展后 365 天 MOQ 订货中心常年展厅、全俄多场展会产品曝光、本土分销布局、品牌化运营指导等，助力参展企业高效开拓俄罗斯及周边国家 market.`
        }
      ]
    },
    contact: {
      title: '联系我们',
      email: '咨询邮箱',
      phone: '咨询热线',
      address: '办公地址'
    }
  },
  en: {
    nav: { about: 'About', services: 'Services', contact: 'Contact' },
    aboutDescription: 'AUCHIEF EXPO (Shanghai) Co., Ltd. is deeply rooted in the Russian-speaking market, specializing in China-Russia bilateral trade. Over years of dedicated operation, we have empowered more than a thousand Chinese exporters to successfully enter the Russian market. In 2024, AUCHIEF forged strategic partnerships with the Longcheng Digital E-commerce Technology Park and the Tianya Auto Parts City in Russia, further strengthening our commitment to serving China\'s export trade. We provide comprehensive "Going Global" solutions through localized physical presence—including year-round showrooms and MOQ order centers—integrated with offline buyer engagement and a dual-channel online/offline distribution model. Our mission is to provide "Made in China" with bespoke, full-service marketing strategies to master the Russian-speaking market.',
    advantages: {
      title: 'Our Advantages',
      list: [
        { title: 'Senior Team', desc: 'Members with diverse backgrounds, rich business experience, multilingual abilities, and overseas work experience.', icon: '👥' },
        { title: 'Quality Resources', desc: 'Years of engagement in international markets, focus on Belt and Road countries, with rich business resources and databases.', icon: '💎' },
        { title: 'Professional Promotion', desc: 'Deep focus on the Russian-speaking region, global market reach, and a strong overseas service team.', icon: '📢' },
        { title: 'Diverse Services', desc: 'Online-offline integration, domestic-overseas presence, providing high-value business consulting services.', icon: '🛠️' }
      ]
    },
    credentials: {
      title: 'Our Credentials'
    },
    exhibitionsSnap: {
      title: 'Past Exhibitions'
    },
    hero: { 
      title: 'Connecting Sino-Russian Markets', 
      subtitle: 'Empowering Chinese manufacturers to expand into the Russian market through premium exhibition services and expert strategic consultancy.', 
      cta: 'Get Started' 
    },
    services: {
      title: 'Core Services',
      list: [
        { title: 'Exhibition Organizing', desc: 'Connecting quality suppliers with top-tier Russian industry events.', icon: '🌍' },
        { title: 'Booth Design', desc: 'Local Moscow engineering team providing turnkey booth solutions.', icon: '🏗️' },
        { title: 'Moscow MOQ Order Center', desc: 'Spot display and distribution center in central Moscow, supporting small orders and quick restock.', icon: '🏢' },
        { title: 'Business Consulting', desc: 'Bilingual experts solving logistics, customs, and market entry issues.', icon: '💼' }
      ]
    },
    industries: {
      title: 'Industry Focus',
      list: [
        { title: 'Home Appliances', icon: '🏠', image: '/core_business_images/xjd.jpg' },
        { title: 'Auto Parts', icon: '🚗', image: '/core_business_images/qcpj.jpg' },
        { title: 'Toys', icon: '🧸', image: '/core_business_images/wj.jpg' },
        { title: 'Cleaning Products', icon: '🧹', image: '/core_business_images/qj.jpg' }
      ]
    },
    workflow: {
      title: 'Our Workflow',
      list: [
        { title: 'Consulting', desc: 'Understanding your product and goals.', icon: '01' },
        { title: 'Strategy', desc: 'Tailored booth design and market entry plan.', icon: '02' },
        { title: 'Agreement', desc: 'Confirming partnership and preparation.', icon: '03' },
        { title: 'Execution', desc: 'On-site support and buyer engagement.', icon: '04' }
      ]
    },
    exhibitionTable: { title: '', columns: [] },
    contact: {
      title: 'Contact Us',
      email: 'Email',
      phone: 'Phone',
      address: 'Office'
    }
  },
  ru: {
    nav: { about: 'О нас', services: 'Услуги', contact: 'Контакты' },
    aboutDescription: 'Компания AUCHIEF EXPO (Шанхай) обладает глубокой экспертизой на русскоязычном рынке, специализируясь на содействии китайско-российской торговле. За годы успешной работы мы оказали поддержку более чем тысяче китайских предприятий, экспортирующих продукцию в Россию. В 2024 году AUCHIEF заключила стратегическое соглашение о сотрудничестве с российским Технопарком цифровой электронной коммерции «Лунчэн» и автоцентром «Тянья». Мы стремимся к постоянному совершенствованию услуг для поддержки китайского экспорта. AUCHIEF предлагает комплексные решения для выхода китайских компаний на внешние рынки, используя физические площадки в России (постоянные шоурумы и центры заказов MOQ), программы по привлечению покупателей и гибридную модель онлайн- и офлайн-дистрибуции. Мы создаем индивидуальные маркетинговые стратегии, помогая бренду «Сделано в Китае» эффективно расширять свое присутствие в русскоязычном регионе.',
    hero: { 
      title: 'Ваш мост в бизнес между Китаем и Россией', 
      subtitle: 'Профессиональная организация выставок и комплексный бизнес-консалтинг для эффективного развития вашего бизнеса на рынках России и СНГ.', 
      cta: 'Связаться' 
    },
    advantages: {
      title: 'Наши преимущества', 
      list: [
        { title: 'Опытная команда', desc: 'Члены команды с многообразным опытом, богатым опытом в бизнесе, знанием нескольких иностранных языков и опытом работы за рубежом.', icon: '👥' },
        { title: 'Качественные ресурсы', desc: 'Многолетняя работа на международных рынках, фокус на странах «Один пояс, один путь», богатые деловые ресурсы и базы данных.', icon: '💎' },
        { title: 'Профессиональное продвижение', desc: 'Глубокая экспертиза в русскоязычном регионе, охват мирового торгового рынка и сильная зарубежная сервисная команда.', icon: '📢' },
        { title: 'Разнообразные услуги', desc: 'Интеграция онлайн и офлайн, работа внутри страны и за рубежом, предоставление консультационных услуг с высокой добавленной стоимостью.', icon: '🛠️' }
      ]
    },
    credentials: {
      title: 'Наши сертификаты'
    },
    exhibitionsSnap: {
      title: 'Прошедшие выставки'
    },
    services: {
      title: 'Наши Услуги',
      list: [
        { title: 'Организация выставок', desc: 'Содействие китайским компаниям в участии в ведущих выставках РФ.', icon: '🌍' },
        { title: 'Дизайн стендов', desc: 'Собственная строительная бригада в Москве, застройка «под ключ».', icon: '🏗️' },
        { title: 'Центр заказов MOQ в Москве', desc: 'Центр демонстрации и дистрибуции товаров в Москве, поддержка малых заказов и быстрое пополнение.', icon: '🏢' },
        { title: 'Консалтинг', desc: 'Юридическая поддержка, логистика и таможенное оформление.', icon: '💼' }
      ]
    },
    industries: {
      title: 'Отраслевой фокус',
      list: [
        { title: 'Мелкая бытовая техника', icon: '🏠', image: '/core_business_images/xjd.jpg' },
        { title: 'Автозапчасти', icon: '🚗', image: '/core_business_images/qcpj.jpg' },
        { title: 'Игрушки', icon: '🧸', image: '/core_business_images/wj.jpg' },
        { title: 'Чистящие средства', icon: '🧹', image: '/core_business_images/qj.jpg' }
      ]
    },
    workflow: {
      title: 'Процесс работы',
      list: [
        { title: 'Консультация', desc: 'Понимаем ваш продукт и цели.', icon: '01' },
        { title: 'Стратегия', desc: 'Индивидуальный дизайн и план выхода.', icon: '02' },
        { title: 'Договор', desc: 'Подтверждение партнерства и подготовка.', icon: '03' },
        { title: 'Реализация', desc: 'Поддержка на месте и работа с покупателями.', icon: '04' }
      ]
    },
    exhibitionTable: { title: '', columns: [] },
    contact: {
      title: 'Свяжитесь с нами',
      email: 'Email',
      phone: 'Телефон',
      address: 'Адрес'
    }
  }
};
